/* Progressive enhancement: links and cart forms also work without JavaScript. */
(() => {
  'use strict';
  const isArabic = () => document.documentElement.lang.toLowerCase().startsWith('ar');
  function initTabs(root = document) {
    root.querySelectorAll('[data-raf-tabs]').forEach(section => {
      if (section.dataset.rafReady) return;
      const tabs = Array.from(section.querySelectorAll('[data-raf-tab]'));
      const panels = Array.from(section.querySelectorAll('[data-raf-panel]'));
      if (!tabs.length || tabs.length !== panels.length) return;
      section.dataset.rafReady = 'true';
      section.querySelector('[data-raf-tablist]').setAttribute('role', 'tablist');
      const select = (index, focus = false) => {
        tabs.forEach((tab, i) => {
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
          panels[i].setAttribute('role', 'tabpanel');
          panels[i].tabIndex = 0;
          panels[i].hidden = i !== index;
        });
        if (focus) tabs[index].focus();
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', event => { event.preventDefault(); select(index); });
        tab.addEventListener('keydown', event => {
          let next = index;
          const rtl = document.documentElement.dir === 'rtl';
          if (event.key === 'ArrowRight') next += rtl ? -1 : 1;
          else if (event.key === 'ArrowLeft') next += rtl ? 1 : -1;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = tabs.length - 1;
          else return;
          event.preventDefault();
          select((next + tabs.length) % tabs.length, true);
        });
      });
      select(0);
    });
  }
  initTabs();
  document.addEventListener('shopify:section:load', event => initTabs(event.target));
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-raf-add]') || !window.fetch) return;
    event.preventDefault();
    if (form.dataset.pending === 'true') return;
    const button = form.querySelector('button[type="submit"]');
    const label = form.querySelector('[data-raf-button-label]');
    const status = form.querySelector('[data-raf-status]');
    const recovery = form.querySelector('[data-raf-recovery]');
    const originalLabel = label.textContent;
    form.dataset.pending = 'true';
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    label.textContent = isArabic() ? 'جاري الإضافة…' : 'Adding…';
    status.hidden = true;
    recovery.hidden = true;
    let confirmed = false;
    try {
      const endpoint = new URL(form.action, location.href);
      endpoint.pathname = endpoint.pathname.replace(/\/$/, '') + '.js';
      const payload = new FormData(form);
      payload.delete('return_to');
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 15000);
      let response;
      try {
        response = await fetch(endpoint.href, { method: 'POST', body: payload, headers: { Accept: 'application/json' }, credentials: 'same-origin', signal: controller.signal });
      } finally { clearTimeout(timeout); }
      const data = await response.json();
      if (!response.ok) {
        status.textContent = typeof data.description === 'string' ? data.description : (isArabic() ? 'تعذرت الإضافة. افتح المنتج وراجع الاختيار والكمية.' : 'Unable to add. Open the product to check options and quantity.');
        status.hidden = false;
        recovery.hidden = false;
        return;
      }
      confirmed = true;
      label.textContent = isArabic() ? 'تمت الإضافة ✓' : 'Added ✓';
      if (window.rafCartFeedback) await window.rafCartFeedback(button);
      // Keep browsing. Refresh authoritative cart data without replaying add-to-cart.
      status.textContent = isArabic() ? 'اتضاف للسلة. كمل تسوّق براحتك.' : 'Added to your cart. Keep exploring.';
      status.hidden = false;
      recovery.hidden = false;
      try {
        const refreshController=new AbortController();
        const refreshTimeout=setTimeout(()=>refreshController.abort(),8000);
        let cartResponse;
        try {cartResponse = await fetch(form.dataset.cartUrl.replace(/\/$/, '') + '.js', {credentials:'same-origin', headers:{Accept:'application/json'},signal:refreshController.signal});}
        finally {clearTimeout(refreshTimeout);}
        if(cartResponse.ok){const cart=await cartResponse.json();document.querySelectorAll('[data-cart-count]').forEach(el=>el.textContent=String(cart.item_count));}
        if(window.T4SThemeSP?.Cart?.getToFetch) window.T4SThemeSP.Cart.getToFetch();
      } catch(refreshError) { /* Addition succeeded; keep the explicit cart link available. */ }

    } catch (error) {
      status.textContent = confirmed ? (isArabic() ? 'اتضاف للسلة. كمل تسوّق براحتك.' : 'Added to your cart. Keep exploring.') : isArabic() ? 'تعذر تأكيد الإضافة. راجع سلتك قبل المحاولة مرة تانية.' : 'Could not confirm the addition. Check your cart before trying again.';
      status.hidden = false;
      recovery.hidden = false;
    } finally {
        form.dataset.pending = 'false';
        button.disabled = false;
        button.removeAttribute('aria-busy');
        label.textContent = originalLabel;
    }
  });
})();
